






































































































































import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import { i18n } from '@/i18n/i18n-setup';
import { Grafica } from '@/entity/Pk/Grafica';
import { DropDownItem } from '@/services/DropDownItem';
import { ContenitoreGrafiche } from '@/entity/Pk/ContenitoreGrafiche';
import { SOURCE, GetDropDownListBySource } from '@/services/PkDropDown';
import GraficheList from '@/components/Pk/modules/GraficheList.vue';


@Component({
    components: {
        SearchFilter,
        GraficheList
    }
})

export default class ContenitoreGraficheSearch extends Vue {
    ready: boolean = true;
    filterSelected: boolean = false;
    advCode: string = "";
    advCapitolato: string = "";
    advDescription: string = "";
    advCountry: string = "";
    advDestination: string = "";
    advCapacity: string = "";
    advQuantity: string = "";
    advContAccessorio: string = "";
    advContObj: string = "";

    dropDownModels: DropDownItem[] = [];
    dropDownCountries: any = new Array();
    dropDownDestination: any = new Array();
    dropDownQuantity: any = new Array();
    dropDownCapacity: any = new Array();
    dropDownContAccessorio: any = new Array();
    dropDownContObj: any = new Array();

    codeSelected: string = "";

    get listGraficheModalTitle(): string {
        return `${i18n.t('PK.CONTENITORE_GRAFICHE') as string}: ${this.codeSelected}`;
    }

    resultsItems: any = {
        resultPage: new Array<ContenitoreGrafiche>(),
        total: 0
    };

    resultsItemsGrafiche: any = {
        resultPage: new Array<Grafica>(),
        total: 0
    };

    page: number = 1;
    pageGrafiche: number = 1;
    firstSearch: boolean = false;
    freeText = null;
    showLoading: boolean = false;
    showLoadingGrafica: boolean = false;

    async mounted() {
        this.dropDownCountries = await GetDropDownListBySource(SOURCE.PK_PAESI);
        this.dropDownDestination = await GetDropDownListBySource(SOURCE.PK_DESTINAZIONI);
        this.dropDownQuantity = await GetDropDownListBySource(SOURCE.PK_QUANTITA);
        this.dropDownCapacity = await GetDropDownListBySource(SOURCE.PK_CAPACITA);
        this.dropDownContAccessorio = await GetDropDownListBySource(SOURCE.PK_CONTENITORI_ACCESSORIO);
        this.dropDownContObj = await GetDropDownListBySource(SOURCE.PK_CONTENITORI_OGGETTO);
    }

    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }

    resetGrafiche() {
        this.resultsItemsGrafiche.resultPage.splice(0);
        this.pageGrafiche = 1;
    }

    resetFilters() {
        this.advCode = null;
        this.advCapitolato = null;
        this.advDescription = null;
        this.advCountry = null;
        this.advDestination = null;
        this.advCapacity = null;
        this.advQuantity = null;
        this.advContAccessorio = null;
        this.advContObj = null;
        this.filterSelected = false;
    }

    searchFilter(genericSearch: string) {
        if (genericSearch != null)
            this.freeText = genericSearch;

        this.searchContenitoriGraficheAsync(true)
    }

    openListGrafiche(code: string) {
        this.codeSelected = code;
        this.getGraficheFromContainerCodeAsync(code, true);
        this.$bvModal.show('grafiche-list-modal');
    }

    async getGraficheFromContainerCodeAsync(code: string, isStart: boolean) {
        this.showLoadingGrafica = true;

        if (isStart) {
            this.resetGrafiche();
        }
        try {
            let url = "/api/pk/GetGraficheByContenitoreCodeWithFilterAndPagination?code=" + code + "&currentPage=" + this.pageGrafiche;
            let results: any = await axios({
                method: 'get',
                url: General.GetApiUrl(url),
                withCredentials: true,
                responseType: 'json'
            });
            this.resultsItemsGrafiche.resultPage = this.resultsItemsGrafiche.resultPage.concat(results.data.listPage);
            this.resultsItemsGrafiche.total = results.data.total;

            this.firstSearch = true;
            this.page += 1;
            this.showLoadingGrafica = false;


        } catch (error) {
            General.HandleError(error, this);
            this.showLoadingGrafica = false;
        }
    }

    async searchContenitoriGraficheAsync(start: boolean) {
        this.showLoading = true;
        if (start == true) {
            this.resetSearch();
        }
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl("/api/pk/GetContenitoriGraficheWithFilterAndPagination"),
                data: {
                    FreeText: this.freeText,
                    CurrentPage: this.page,
                    Code: this.advCode,
                    CapitolatoCode: this.advCapitolato,
                    Descrizione: this.advDescription,
                    PaeseId: this.advCountry,
                    CapacitaId: this.advCapacity,
                    QuantitaId: this.advQuantity,
                    ContenitoreAccessorioId: this.advContAccessorio,
                    ContenitoreOggettoId: this.advContObj,
                    DestinazioneId: this.advDestination
                },
                withCredentials: true,
                responseType: 'json'
            });
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;

            this.firstSearch = true;
            this.page += 1;
            this.showLoading = false;

        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }
    }
}
